import React from 'react'
import { Chip } from '@mui/material'
import { BATTERY_STATUS_BADGES } from '../consts'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { EmsBatteryMode } from 'src/Libs/dynamic-power-prices/types'

/**
 * This component is a Badge/Chip for the battery status that is used in AI360°. It has multiple states/options.
 */
const BatteryBadge: React.FC<{ status: EmsBatteryMode }> = ({ status }) => {
  const { t } = useCustomTranslation()
  const statusBadge = BATTERY_STATUS_BADGES.find(badge => badge.status === status)

  return <Chip sx={{ backgroundColor: statusBadge?.color, color: statusBadge?.textColor }} label={t(statusBadge?.label ?? '')} size="small" />
}

export default BatteryBadge
